import { wabunkaGuestTypeNameToJSON } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_guest_type';

import type { WabunkaExperienceFee } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_fee';
import type { WabunkaGuestType, WabunkaGuestTypeName } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_guest_type';

/**
 * ゲストタイプビューモデル
 */
export interface WabunkaGuestTypeViewModel {
  /** ID */
  id: string;
  /** 体験ID */
  experienceId: string;
  /** タイプ名 */
  typeName: string;
  /** 名前 */
  name: string;
  /** 概要 */
  overview: string;
  /** 説明 */
  description: string;
  /** 表示順 */
  sequenceId: number;
  /** 定員に含めるかどうか */
  isIncludedInHeadcountLimit: boolean;
  /** 体験料金 */
  experienceFees: WabunkaExperienceFee[];
}

/**
 * ゲストタイプのデフォルト値を返却する
 */
export const createDefaultWabunkaGuestTypeViewModel = (): WabunkaGuestTypeViewModel => ({
  id: '',
  experienceId: '',
  typeName: '',
  name: '',
  overview: '',
  description: '',
  sequenceId: 0,
  isIncludedInHeadcountLimit: false,
  experienceFees: [],
});

/**
 * APIレスポンスからゲストタイプビューモデルを作成する
 */
export const buildWabunkaGuestTypeViewModel = (res: WabunkaGuestType | undefined): WabunkaGuestTypeViewModel => {
  if (res == null) {
    return createDefaultWabunkaGuestTypeViewModel();
  }
  return {
    id: res.id,
    experienceId: res.experienceId,
    typeName: wabunkaGuestTypeNameToJSON(res.typeName as WabunkaGuestTypeName),
    name: res.name,
    overview: res.overview,
    description: res.description,
    sequenceId: res.sequenceId,
    isIncludedInHeadcountLimit: res.isIncludedInHeadcountLimit,
    experienceFees: res.experienceFees,
  };
};

/**
 * ゲストタイプリスト表示用のビューモデルを組み立てる
 */
export const buildWabunkaGuestTypeListViewModel = (guestTypes: WabunkaGuestType[] | undefined): WabunkaGuestTypeViewModel[] => {
  if (!guestTypes) {
    return [];
  }
  return guestTypes.map(buildWabunkaGuestTypeViewModel);
};
